import { yupResolver } from '@hookform/resolvers/yup'
import * as Yup from 'yup'

import { INSTANT_PAYOUT } from 'constants/calculator'

export const calculatorResolver = yupResolver(
  Yup.object().shape({
    one_time_payout: Yup.number()
      .typeError('Обязательное поле')
      .required('Обязательное поле'),
    instant_payout: Yup.number()
      .typeError('Обязательное поле')
      .min(INSTANT_PAYOUT.min, `Не меньше ${INSTANT_PAYOUT.min}`)
      .max(INSTANT_PAYOUT.max, `Не больше ${INSTANT_PAYOUT.max}`)
      .required('Обязательное поле'),
    plan: Yup.object().shape({
      name: Yup.string().required('Обязательное поле'),
      values: Yup.array().of(
        Yup.object().shape({
          count: Yup.number()
            .typeError('Обязательное поле')
            .required('Обязательное поле'),
          sum: Yup.number()
            .typeError('Обязательное поле')
            .required('Обязательное поле'),
        }),
      ),
    }),
  }),
)
